import { withPlugins, domEvents, device } from '@spon/plugins';

function ReadMore({ node, plugins: { addEvents, device } }) {
	let windowXWidth = window.innerWidth;
	const content = node.querySelector('[data-content]');
	const button = node.querySelector('[data-more]');
	let duration = 200;
	let originalHeight = 0;
	let scrollPos = 0;

	// detect heights
	function lengthCheck() {
		content.style.height = '';
		content.setAttribute('data-height', '');

		duration =
			content.scrollHeight < 200
				? 200
				: content.scrollHeight > 800
				? 800
				: content.scrollHeight;

		content.style.transitionDuration = `${duration}ms`;

		if (content.scrollHeight > content.offsetHeight) {
			// Show button
			button.classList.remove('hidden');
		} else {
			button.classList.add('hidden');
		}
	}
	lengthCheck();

	/*
	 *		Line clamp worked nicely, but there is a bug on safari <=16. So min-height on the container (in twig) is setting the height.
	 * 		I have kepy line clamp on so there is a nice `...` when it does work.
	 */
	function onClick({ target }) {
		// Close up again..
		if (target.classList.contains('is-showing')) {
			target.classList.remove('is-showing');
			target.innerHTML = 'Read more';
			content.style.height = `${originalHeight}px`;

			window.scrollTo({ behavior: 'smooth', top: scrollPos, left: 0 });

			setTimeout(() => {
				content.classList.add('line-clamp-[9]');
				// originalHeight = content.scrollHeight;
				content.removeAttribute('style');
			}, duration);
			// .. Or open it up!
		} else {
			scrollPos = window.scrollY;
			originalHeight = content.offsetHeight;
			target.classList.add('is-showing');
			target.innerHTML = 'Read less';
			content.style.height = `${content.offsetHeight}px`;
			content.style.maxHeight = 'none';
			content.classList.remove('line-clamp-[9]');
			content.style.height = `${content.scrollHeight}px`;
		}
	}

	addEvents({
		'click [data-more]': onClick,
	});

	device.resize(() => {
		// Only resize if moving X
		if (windowXWidth !== window.innerWidth) {
			windowXWidth = window.innerWidth;

			lengthCheck();
		}
	});
}

export default withPlugins(domEvents, device)(ReadMore);
